<template>
  <div class="send-email">
    <div class="pkg-info">
      <div class="item">
        <label>{{ message.Al211  }}:</label>
         <span>{{ pkg_info.title }}</span>
         <div class="openFilder">
          <!-- <i class="material-icons" @click="openLocalFile">folder_open</i> -->
          <a class="folder_open" @click="openLocalFile">{{ message.Sl198 }}</a>
        </div>
      </div>
      <div class="item">
        <label>{{ message.Sl188 }}:</label>
        <span>{{ senderName }}</span>
      </div>
       <div class="item">
        <label>{{ message.Al124 }}:</label>
        <span>{{ pkg_info.notes }}</span>
      </div>
    </div>
    <div class="pkg-download">
      <div v-if="showlogo">
        <div class="download-logo">
          <i class="material-icons none"
            :class="{mainColor:mainColor}">
            cloud_download
          </i>
        </div>
        <div class="pkg-opt">
          <span>{{ message.S102 }}:</span>
          <span>&nbsp;{{ pkgSize }}&nbsp;</span>
          <a class="check-detail mainColor"
            href="javascript:void(1)"
            @click="showDomnloadDetail">
            {{ message.Al212 }}
          </a>
        </div>
        <div v-if="!showDownload"
          class="download-immediately"
          :class="{disableColor:disableColor}"
          @click="downloadImmedi">
         {{ message.Al180l1 }}
        </div>
        <div v-if="showDownload" class="show-download">
          <div v-if="redownload" class="download-immediately"
            style="padding:0;margin:10px auto;"
            :class="{disableColor:disableColor}"
            @click="downloadImmedi">
            {{ message.Al216 }}
          </div>
          <span class="download-persent">
            <label class="title">{{ message.Al215 }}:</label>
            <span>{{ downloadPensent }}%&nbsp;&nbsp;</span>
          </span>
          <span v-if="taskState !== 2">
            <span v-if="taskState === 0">
              {{message.Al100}}
            </span>
            <span v-else-if="taskState === 1">
              {{message.Al101}}
            </span>
            <span  v-else-if="taskState === 3">
              {{message.Al102}}
            </span>
            <span v-else-if="taskState === 4">
              <i class="el-icon-loading"></i> {{message.Al103}}
            </span>
            <span v-else-if="taskState === 5">
              <i class="el-icon-loading"></i> {{message.Al104}}
            </span>
            <span v-else-if="taskState === 6">
              {{message.Al105}}
            </span>
            <span v-else-if="taskState === 7">
              {{message.Al150}}
            </span>
            <span class="show-error" v-else :title="message.Al151">
              {{message.Al151}}
            </span>
          </span>
          <span class="status" v-if="taskState === 2">
            <span>
              {{ message.Sl109 }}
            </span>
          </span>
          <el-progress :show-text="false" :stroke-width="8" :percentage="downloadPensent"></el-progress>
        </div>
      </div>
      <div v-if="showFiles" class="file-wrap">
        <i class="material-icons reply" @click="returnDownload">keyboard_backspace</i>
        <div class="fileListTitle">
          <div class="name">{{ message.Al214 }}</div>
          <div class="refesh">
            <i class="material-icons" :class="{refresh_animation:flagAnimation}" @click="refesh">autorenew</i>
          </div>
        </div>
        <div class="fileList" v-loading="filesLoading">
          <comp-files
            v-for = "file in files"
            :key = "file.id"
            :id="file.id"
            :name="file.name"
            :size="file.size"
            :percent="file.persent"
            :fileState="file.state"
            :checkedList="checkedList"
            @cellChecked="checkedFiles">
          </comp-files>
        </div>
        <div class="page" v-show="total > 8">
          <el-pagination
            small
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="total"
            :current-page.sync="num"
            @current-change="pageList">
          </el-pagination>
        </div>
        <div class="download-bottom">
          <div class="persent-bottom">
            <label class="title">{{ message.Al215 }}:</label>
            <span>{{ downloadPensent }}%</span>
          </div>
          <div class="bottom-progress">
            <el-progress :show-text="false" :stroke-width="8" :percentage="downloadPensent"></el-progress>
          </div>
        </div>
      </div>
      <router-link class="more-opt" :to="{path: '/inbox'}">{{ message.Al213 }}</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompFiles from '@/components/other/workspace/components/files.vue'
export default {
  name: 'Send',
  data () {
    return {
      message: {
        Al100: this.$lang.ui.app.l100,
        Al101: this.$lang.ui.app.l101,
        Al102: this.$lang.ui.app.l102,
        Al103: this.$lang.ui.app.l103,
        Al104: this.$lang.ui.app.l104,
        Al105: this.$lang.ui.app.l105,
        Al106: this.$lang.ui.app.l106,
        Al107: this.$lang.ui.app.l107,
        Al108: this.$lang.ui.app.l108,
        Al109: this.$lang.ui.app.l109,
        Al110: this.$lang.ui.app.l110,
        Al111: this.$lang.ui.app.l111,
        Al211: this.$lang.ui.app.l211,
        Al212: this.$lang.ui.app.l212,
        Al213: this.$lang.ui.app.l213,
        Al214: this.$lang.ui.app.l214,
        Al215: this.$lang.ui.app.l215,
        Al216: this.$lang.ui.app.l216,
        Al124: this.$lang.ui.app.l124,
        Al150: this.$lang.ui.app.l150,
        Al151: this.$lang.ui.app.l151,
        Al180: this.$lang.ui.app.l180,
        Al180l1: this.$lang.ui.app.l180.l1,
        Sl188: this.$lang.ui.system.l188,
        Sl198: this.$lang.ui.system.l198,
        S102: this.$lang.ui.system.pkgInfo.l02,
        Sl109: this.$lang.ui.notice.l109
      },
      mainColor: true,
      downloadPensent: 0,
      showDownload: false,
      packageid: '',
      files: [],
      showFiles: false,
      filesLoading: false,
      disableColor: false,
      redownload: false,
      showlogo: true,
      total: 0,
      num: 1,
      pageSize: 8,
      checkedList: [],
      pkg_info: {},
      senderName: '',
      pkgSize: 0,
      fileIds: [],
      flagAnimation: false,
      initData: false,
      taskId: '',
      taskState: 0,
      fileid: '',
      taskEventFlag: false,
      hasDownloadTask: []
    }
  },
  computed: {
    ...mapGetters({
      app: 'app',
      transfer: 'transfer'
    })
  },
  watch: {
    'app.login' (val) {
      if (val) {
        this.mainColor = false
        this.disableColor = true
      } else {
        this.mainColor = true
        this.disableColor = false
      }
    },
    initData () {
      if (this.initData) {
        this.pkginfo()
        this.fileList(this.num, 8)
        this.fileList()
      }
    },
    'transfer.aliveList' () {
      if (this.transfer.aliveList) {
        this.mainColor = true
        this.disableColor = false
      }
      if (this.transfer.aliveList.error !== 0) {
        return
      }
      if (this.transfer.aliveList.taskEvents.length !== 0) {
        for (let i = 0; i < this.transfer.aliveList.taskEvents.length; i++) {
          if (this.taskId === this.transfer.aliveList.taskEvents[i].taskId) {
            this.taskEventFlag = true
          }
        }
      }
      if (this.taskEventFlag) {
        this.$app.taskMore('download', this.taskId, res => {
          this.taskState = res.taskState
          if (res.taskState === 2) {
            this.taskId = ''
            this.taskEventFlag = false
            this.downloadPensent = 100
            this.getAllTaskList()
          } else {
            this.downloadPensent = parseInt(res.transfer.percent)
          }
        })
      }
      if (this.transfer.aliveList.tasks.length !== 0) {
        this.transfer.aliveList.tasks.forEach(item => {
          if (item.packageId === this.packageid) {
            this.taskEventFlag = true
            this.taskId = item.taskId
            this.showDownload = true
          }
        })
      }
    }
  },
  components: {
    CompFiles
  },
  created () {
    this.getTokenInfo()
    this.getAllTaskList()
    this.checkTask()
  },
  mounted () {
    if (!this.app.login) {
      this.mainColor = false
      this.disableColor = true
    }
  },
  methods: {
    checkTask () {
      if (this.transfer.aliveList.tasks.length > 0) {
        this.transfer.aliveList.tasks.forEach(item => {
          if (item.packageId === this.packageid) {
            this.mainColor = false
            this.showDownload = true
          } else {
            this.mainColor = true
            this.showDownload = false
          }
        })
      } else {
        this.mainColor = true
        this.showDownload = false
      }
    },
    getTokenInfo () {
      let pathname = window.location.pathname
      let index = pathname.lastIndexOf('/')
      let token = pathname.substring(index + 1, pathname.length)
      this.$api.getDownloadFilesInfo(token, res => {
        if (res.err === 1) {
          this.$router.push({
            path: '/app/workspace'
          })
        } else {
          this.packageid = res.data.pkg_download.pkg_info.id
          this.pkg_info = res.data.pkg_download.pkg_info
          this.senderName = res.data.pkg_download.pkg_info.sender.user.name
          this.pkgSize = this._global.trafficSwitch(res.data.pkg_download.pkg_info.size)
          this.initData = true
        }
      })
    },
    pkginfo () {
      var e = {
        op: 'download',
        with_receivers: 1
      }
      this.$api.getPkgMore(this.packageid, e, res => {
        this.pkgDetail = res
      })
    },
    fileList (pageNum, pageSize) {
      if (pageSize) {
        var paramsData = {
          'op': 'download',
          'with_state': 1,
          'page_num': pageNum,
          'page_size': pageSize
        }
      } else {
        paramsData = {
          'op': 'download',
          'with_sender': 1,
          'with_state': 1,
          'page_num': pageNum,
          'page_size': pageSize
        }
      }
      this.$http.get('/cydex/api/v1/packages/' + this.packageid + '/files', { params: paramsData })
        .then(res => {
          if (pageSize) {
            this.files = []
            this.fileid = res.data.files[0].id
            this.total = res.data.total_num
            res.data.files.forEach(item => {
              this.files.push({
                id: item.id,
                name: item.name,
                size: this._global.trafficSwitch(item.size),
                state: 'download',
                persent: parseInt(item.state.finished_size / item.size * 100)
              })
            })
          } else {
            this.fileIds = []
            res.data.files.forEach(item => {
              this.fileIds.push(item.id)
            })
          }
        })
    },
    getAllTaskList () {
      this.hasDownloadTask = []
      let params = {
        taskType: 'all',
        taskFinish: 1
      }
      this.$app.list(params, res => {
        res.tasks.forEach(item => {
          if (item.taskType === 1) {
            // 1代表下载
            this.hasDownloadTask.push(item.packageId)
          }
        })
        let hasTask = this.hasDownloadTask.some(item => {
          return (item === this.packageid)
        })
        if (hasTask) {
          this.taskState = 2
          this.downloadPensent = 100
          this.showDownload = true
          this.redownload = true
        } else {
          this.redownload = false
          this.downloadPensent = 0
          this.showDownload = false
        }
      })
    },
    downloadImmedi () {
      this.download()
      // this.fileList(this.num, 8)
      this.downloadPensent = 0
      this.showDownload = true
    },
    pageList (index) {
      this.fileList(this.num, 8)
    },
    download () {
      let start = {
        'taskType': 'download',
        'start': 1,
        'pkgId': this.packageid,
        'fileIds': this.fileIds
      }
      this.$app.newTask(start, res => {
        if (res.error === 0 || res.error === 100) {
          this.$message({
            message: this.$lang.ui.prompt.l109,
            type: 'success',
            duration: 4000
          })
          this.taskState = res.taskState
          this.taskId = res.taskId
          setTimeout(() => {
            this.$store.dispatch('transferEl', 'download')
          }, 200)
        } else {
          if (res.error === 4 || res.error === 104) {
            this.$message({
              message: this.$lang.ui.prompt.l110,
              type: 'warning'
            })
          }
        }
      })
    },
    checkedFiles (msg) {
      if (msg.checked) {
        this.checkedList.push({
          id: msg.id
        })
      } else {
        for (var i = 0; i < this.checkedList.length; i++) {
          if (this.checkedList[i].id === msg.id) {
            this.checkedList.splice(i, 1)
          }
        }
      }
    },
    refesh () {
      this.flagAnimation = true
      this.fileList(this.num, 8)
      setTimeout(() => {
        this.flagAnimation = false
      }, 3000)
    },
    showDomnloadDetail () {
      this.showFiles = true
      this.showlogo = false
      this.fileList(this.num, 8)
    },
    returnDownload () {
      this.showFiles = false
      this.showlogo = true
    },
    openLocalFile () {
      this.$store.dispatch('alertWarn', false)
      if (this.app.login) {
        let params = {
          taskType: 'download',
          fileId: this.fileid
        }
        this.$app.openFileLocation(params, res => {
        })
      } else {
        if (!this.app.login) {
          this.$app.login(0, response => {
            if (response === 2) {
              this.$app.start()
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="css">
.mainColor {
  color: #09f !important;
}
.disableColor {
  background-color: #e5e5e5 !important;
  color: #333 !important;
}
.send-email {
  width: 650px;
  min-width: 550px;
  height: 600px;
  margin: 0 auto;
  position: relative;
  border: 1px solid #e5e5e5;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.pkg-info {
  padding: 25px 0;
  border-bottom: 1px solid #e5e5e5;
}
.pkg-info .item {
  line-height: 30px;
  padding: 0 50px;
}
.pkg-info .openFilder {
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.pkg-info .openFilder .folder_open {
  color: #2196F3;
  text-decoration: underline;
}
.pkg-download {
  text-align: center;
  padding: 35px 0;
}
.pkg-download  .download-logo {
  margin: 0 auto;
}
.pkg-download  .download-logo i {
  font-size: 128px;
  color: #cdcdcd;
}
.pkg-download .more-opt {
  left: 50px;
  bottom: 15px;
  color: #09f;
  position: absolute;
}
.pkg-download .download-immediately {
  overflow: hidden;
  width: 128px;
  padding: 6px 12px;
  font-size: 14px;
  color: white;
  background-color: #2196F3;
  text-align: center;
  margin: 15px auto;
  text-decoration: none;
  cursor: pointer;
}
.show-download {
  width: 220px;
  display: inline-block;
  line-height: 40px;
  margin: 0 auto;
}
.download-persent {
  margin: 10px 0;
}
.fileList {
  position: relative;
  padding: 0 35px;
  height: 272px;
  overflow: hidden;
}
.file-wrap {
  position: relative;
}
.file-wrap .reply {
  position: absolute;
  left: 10px;top:-25px;
}
.file-wrap .reply:hover {
  cursor: pointer;
  color: #09f;
}
.fileListTitle {
  padding: 0 35px;
  overflow: hidden;
  height: 34px;
  line-height: 34px;
}
.fileListTitle .name {
  width: 300px;
  float: left;
  text-align: left;
  margin-left: 18px;
}
.fileListTitle .refesh {
  width: 120px;
  float: right;
  margin-right: 60px;
}
.fileListTitle .refesh i {
  vertical-align: middle;
  color: rgba(117, 117, 117, 0.7);
}
.fileListTitle .refesh:hover i {
  cursor: pointer;
  color: #212121;
}
.refresh_animation {
  transform: rotate(1080deg);
  transition: all 3s;
}
.download-bottom {
  padding: 0 53px;
  height: 34px;
  text-align: left;
}
.download-bottom .persent-bottom,.download-bottom .bottom-progress {
  float: left;
  line-height: 34px;
}
.download-bottom .bottom-progress {
  width: 30%;
  padding: 12px 0;
}
.download-bottom .persent-bottom {
  width: 260px;
}
</style>
